import arTranslations from './ar.json';
import csTranslations from './cs.json';
import daTranslations from './da.json';
import deTranslations from './de.json';
import enTranslations from './en.json';
import esTranslations from './es.json';
import filTranslations from './fil.json';
import frTranslations from './fr.json';
import hiTranslations from './hi.json';
import huTranslations from './hu.json';
import idTranslations from './id.json';
import itTranslations from './it.json';
import koTranslations from './ko.json';
import mnTranslations from './mn.json';
import msTranslations from './ms.json';
import nlTranslations from './nl.json';
import noTranslations from './no.json';
import plTranslations from './pl.json';
import ptTranslations from './pt.json';
import roTranslations from './ro.json';
import ruTranslations from './ru.json';
import svTranslations from './sv.json';
import thTranslations from './th.json';
import trTranslations from './tr.json';
import viTranslations from './vi.json';
import zhTranslations from './zh.json';
export const ar = arTranslations;
export const cs = csTranslations;
export const da = daTranslations;
export const de = deTranslations;
export const en = enTranslations;
export const es = esTranslations;
export const ph = filTranslations;
export const fr = frTranslations;
export const hi = hiTranslations;
export const hu = huTranslations;
export const id = idTranslations;
export const it = itTranslations;
export const ko = koTranslations;
export const mn = mnTranslations;
export const ms = msTranslations;
export const nl = nlTranslations;
export const no = noTranslations;
export const pl = plTranslations;
export const pt = ptTranslations;
export const ro = roTranslations;
export const ru = ruTranslations;
export const sv = svTranslations;
export const th = thTranslations;
export const tr = trTranslations;
export const vi = viTranslations;
export const zh = zhTranslations;
